import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/icons/Logo';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { SunIcon, MoonIcon, GlobeAltIcon } from '@heroicons/react/24/outline';

const PrivacyPolicy: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { language, setLanguage } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      {/* Theme and Language Selectors */}
      <div className="absolute top-4 right-4 z-20 flex items-center space-x-3">
        {/* Theme Selector */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm hover:bg-white/90 dark:hover:bg-gray-800/90 transition-all duration-200 shadow-md"
          aria-label={theme === 'light' ? 'Váltás sötét módra' : 'Váltás világos módra'}
        >
          {theme === 'light' ? (
            <MoonIcon className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          ) : (
            <SunIcon className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          )}
        </button>

        {/* Language Selector */}
        <button
          onClick={() => setLanguage(language === 'hu' ? 'en' : 'hu')}
          className="p-2 rounded-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm hover:bg-white/90 dark:hover:bg-gray-800/90 transition-all duration-200 shadow-md flex items-center space-x-1"
          aria-label={language === 'hu' ? 'Switch to English' : 'Váltás magyarra'}
        >
          <GlobeAltIcon className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300 uppercase">
            {language === 'hu' ? 'EN' : 'HU'}
          </span>
        </button>
      </div>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <Link to="/">
            <Logo className="h-16 mx-auto" showCompanyName={false} />
          </Link>
          <h1 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-white">Adatvédelmi Szabályzat</h1>
        </div>
        
        <div className="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6 prose dark:prose-invert max-w-none text-gray-900 dark:text-gray-100">
            <h2>1. Bevezetés</h2>
            <p>
              A YouCRM elkötelezett az Ön adatainak védelme mellett. Ez az Adatvédelmi Szabályzat 
              elmagyarázza, hogyan gyűjtjük, használjuk és védjük az Ön adatait, amikor a YouCRM 
              rendszerünket használja.
            </p>
            
            <h2>2. Milyen adatokat gyűjtünk</h2>
            <p>
              Olyan információkat gyűjtünk, amelyeket Ön közvetlenül szolgáltat számunkra, beleértve a személyes 
              adatokat, mint például a nevét, e-mail címét és egyéb kapcsolattartási adatait. Továbbá gyűjtjük 
              az Ön ügyfeleivel, beszállítóival és üzleti partnereivel kapcsolatos információkat, amelyeket 
              Ön a rendszerbe rögzít.
            </p>

            <h2>3. Hogyan használjuk az adatait</h2>
            <p>
              Az általunk gyűjtött információkat a szolgáltatásaink nyújtására, fenntartására és javítására, 
              új funkciók fejlesztésére, valamint felhasználóink védelmére használjuk. A rendszer érzékeny 
              üzleti információkat tartalmaz, amelyekhez csak jogosult személyek férhetnek hozzá.
            </p>

            <h2>4. Adatbiztonság</h2>
            <p>
              Megfelelő biztonsági intézkedéseket hajtunk végre az Ön adatainak jogosulatlan hozzáféréstől, 
              módosítástól, közzétételtől vagy megsemmisítéstől való védelme érdekében. Azonban nincs olyan 
              internetes adatátviteli vagy elektronikus tárolási módszer, amely 100%-ban biztonságos lenne.
            </p>

            <h2>5. Adatmegőrzés</h2>
            <p>
              Adatait mindaddig megőrizzük, amíg fiókja aktív, vagy amíg szükséges a szolgáltatások nyújtásához. 
              Adatait a szükséges mértékben megtartjuk és felhasználjuk jogi kötelezettségeink teljesítése, 
              viták rendezése és megállapodásaink betartatása érdekében.
            </p>

            <h2>6. Az Adatvédelmi Szabályzat módosításai</h2>
            <p>
              Időről időre frissíthetjük Adatvédelmi Szabályzatunkat. Az esetleges változásokról értesítjük Önt 
              az új Adatvédelmi Szabályzat ezen az oldalon történő közzétételével és a hatályba lépés dátumának 
              frissítésével.
            </p>

            <div className="mt-8 text-center">
              <Link to="/login" className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300">
                Vissza a bejelentkezéshez
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 